
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import React, { useEffect, useState } from 'react';
import api from '../Utility/middleware';
import Loader from '../GlobalComponents/Loader/Loader';
import apiMiddleware from '../Utility/middleware';
import TimeConverter from '../GlobalComponents/UAETIMECONVERT/TimeConvert';
import { useParams } from 'react-router-dom';



const Notification = () => {
    const { id } = useParams();



    // State to store the fetched data
    const [Notification, setNotification] = useState([]);
    // State to handle loading state
    const [loading, setLoading] = useState(true);
    // State to handle errors
    const [error, setError] = useState(null);


    const [PingData, setPingData] = useState(null);  // Initialize as null instead of false

    useEffect(() => {
        setLoading(true);
        handleCrudOperation();

        const interval = setInterval(() => {
            handleCrudOperation();
        }, 3000);

        return () => clearInterval(interval);


    }, []);

    const handleCrudOperation = async () => {
        const body = {
            "queryType": "custom-query",
            "table": "DevicesPing_Log",
            "data": {
                "query": `SELECT * 
FROM DevicesPing_Log
WHERE updated_at BETWEEN CURDATE() - INTERVAL 2 DAY AND CURDATE() + INTERVAL 2 DAY
ORDER BY 
    (Running_status = 'Running') DESC,  -- Prioritize Running status
    ABS(TIMESTAMPDIFF(SECOND, updated_at, NOW())) ASC;  -- Order by closest updated_at to current time

`
            }
        };

        const response = await apiMiddleware('POST', body);

        if (response.success) {
            setLoading(false);
            setNotification(response.data);


        } else {
            console.error('CRUD Operation Failed:', response.error);
        }
    };


    const buttons = [
        { name: "Network Switches", key: "network" },
        { name: "AV Devices", key: "av" },
        { name: "PDU Devices", key: "pdu" },
    ];

    const [activeButton, setActiveButton] = useState(id);
    const [Btn, setBtn] = useState(id);
    const handleButtonClick = (button) => {
        setActiveButton(button.key);

        setBtn(button.key);


    };


    // return no data found mesage when Notification is null



    function convertTo12HourFormat(dateTimeStr) {
        // Convert the string to a Date object
        const date = new Date(dateTimeStr);

        // Extract day, month, and year
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();

        // Extract hours and minutes
        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');

        // Determine AM/PM and convert hours to 12-hour format
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12; // Convert 0 to 12 for midnight

        // Format hours with leading zero if needed
        const formattedHours = String(hours).padStart(2, '0');

        // Return the formatted date-time string
        return `${day}-${month}-${year} ${formattedHours}:${minutes} ${ampm}`;
    }




    return (
        <>
            <Helmet>
                <title>
                    Notification
                </title>
            </Helmet>

            <section className="bg-SoftBlack h-full md:mt-0 md:px-12 mt-16   md:pt-1 ">
                <section className="w-full  bg-SoftBlack">

                    {/* Button Group */}
                    <ul className={`w-full flex items-center md:pt-0 pt-4 `}>
                        {buttons.map((button) => (
                            <li
                                key={button.name}
                                className={` md:text-xl text-sm md:px-0 px-2 text-white w-full items-center text-center flex justify-center h-[2.75rem] ${activeButton === button.key ? "border-b-4 border-DarkRed" : "border-b-4 opacity-35"}`}
                            >
                                <button onClick={() => handleButtonClick(button)}>{button.name}</button>
                            </li>
                        ))}
                    </ul>
                </section>
                <ul className="bg-DarkBlue overflow-x-scroll overflow-y-scroll h-[80vh] p-5">


                    {Notification ? (Notification?.filter(row => row.Device_Type === Btn).map((data, index) => (
                        console.log(data),

                        !data.id ? (
                            <div className="text-center w-full h-full">
                                <h1 className="text-2xl font-bold">No Data Found</h1>
                            </div>
                        ) : (
                            <li key={index} >
                                <Link to={`/maintenance-schedules/${data?.device_ip}`} className="flex items-center gap-3 p-3 border-b border-gray-600">
                                    <figure className="flex-shrink-0">
                                        {/* <img
                                    className={`${data.Running_status === 'Running' && 'animate-spin'} w-6 h-6`}
                                    src={`/Icons/${data.Running_status === 'Completed' ? 'Completed.svg' : data.Running_status === 'Sheduled' ? 'process.svg' : data.Running_status === 'Running' && 'process.svg'}`}
                                    alt={data.Device}
                                    title={data.Running_status}

                                /> */}


                                        {
                                            data.Running_status === 'Sheduled' ? (
                                                <img
                                                    className="w-6 h-6"
                                                    src="/Icons/process.svg"
                                                    alt={data.Device}
                                                    title="Scheduled: Device is scheduled to run"
                                                />
                                            ) : data.Running_status === 'Running' ? (
                                                <img
                                                    className="w-6 h-6 animate-spin"
                                                    src="/Icons/process.svg"
                                                    alt={data.Device}
                                                    title="Running: Device is currently running"
                                                />
                                            ) : data.Running_status === 'Completed' &&
                                                data.Device_status === 'Healthy' &&
                                                data.device_working_status === 'Warning' ? (
                                                <img
                                                    className="w-6 h-6"
                                                    src="/Icons/Eror1.png"
                                                    alt={data.Device}
                                                    title="Warning: Device completed with warnings"
                                                />
                                            ) : data.Running_status === 'Completed' &&
                                                data.Device_status === 'Unresponsive' &&
                                                data.device_working_status !== 'Warning' ? (
                                                <img
                                                    className="w-6 h-6"
                                                    src="/Icons/CloseX.svg"
                                                    alt={data.Device}
                                                    title="Error: Device is unresponsive"
                                                />
                                            ) : data.Running_status === 'Completed' &&
                                                data.Device_status === 'Delay' &&
                                                data.device_working_status !== 'Warning' ? (
                                                <img
                                                    className="w-6 h-6"
                                                    src="/Icons/Eror1.png"
                                                    alt={data.Device}
                                                    title="Delay: Device is delayed"
                                                />
                                            ) : data.Running_status === 'Completed' ? (
                                                <img
                                                    className="w-6 h-6"
                                                    src="/Icons/Completed.svg"
                                                    alt={data.Device}
                                                    title="Completed: Task is completed"
                                                />
                                            ) : null
                                        }





                                    </figure>
                                    <div className=' flex-grow'>
                                        <span className="text-white">
                                            {/* {data.Running_status === 'Completed' && (
data.Device_status === 'Healthy' ? (
<span className="text-green-400 font-semibold">Hurray!</span>
) : data.device_working_status === 'Warning' && data.Device_status === 'Healthy' ? (
<span className="text-yellow-400 font-semibold">Wew!</span>
) : null
)} */}

                                            {data.Running_status === 'Completed' && data.Device_status === 'Healthy' && data.device_working_status === 'Warning' ? (
                                                <span className="text-yellow-400 font-semibold">Wew!</span>
                                            ) : data.Running_status === 'Completed' && data.Device_status === 'Healthy' ? (
                                                <span className="text-green-400 font-semibold">Hurray!</span>
                                            ) : data.Running_status === 'Completed' && data.Device_status === 'Unresponsive' ? (
                                                <span className="text-red-500 font-semibold">Boo!</span>
                                            ) : null /* Add fallback here if needed */}





                                            <span className="text-gray-300"> Maintenance Scheduled For Device </span>
                                            <span className="font-semibold text-white">{data.device_ip}</span>
                                            {
                                                data.Device_Type === 'av' ? (
                                                    <span className="text-gray-300 ml-1">At {data.Device_location}</span>
                                                ) : (
                                                    <span className="text-gray-300 ml-1">At Device Location  {data.Device_location}</span>
                                                )
                                            }

                                            <span className="text-gray-300 ml-1 mr-1"> on  {convertTo12HourFormat(data?.updated_at)}</span>

                                            {data.Device_status === 'Healthy' ? (
                                                data.device_working_status === 'Warning' ? (
                                                    <span className="text-yellow-500 font-semibold">Is Completed With Warning.</span>
                                                ) : (
                                                    <span className="text-green-400 font-semibold">Is Completed.</span>
                                                )
                                            ) : data.Device_status === 'Unresponsive' ? (
                                                <span className="text-red-500 font-semibold">Is Not Responding.</span>
                                            ) : data.Device_status === 'Delayed' ? (
                                                <span className="text-yellow-500 font-semibold">Having Delayed Response.</span>
                                            ) : data.Running_status === 'Sheduled' ? (
                                                <span>Is Scheduled.</span>
                                            ) : (
                                                <span className="text-blue-500 font-semibold">In Progress...</span>
                                            )}

                                        </span>

                                    </div>
                                </Link >
                            </li>
                        )
                    ))) : (<div className="text-center w-full h-full">
                        <h1 className="text-2xl font-bold">No Data Found</h1>
                    </div>)}
                </ul>
            </section>
        </>
    );
};

export default Notification;
